<template>
    <div class="news-add">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-card class="mt-8">
                        <v-card-title class="dark--text subtitle-1 font-weight-bold">
                            <v-btn depressed rounded class="secondary mx-2" dark @click="() => $router.go(-1)">
                                <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            {{ "ပြင်မည်" }}
                            <v-spacer></v-spacer>
                            <v-btn rounded depressed class="primary" @click="saveItem()" large dark
                                :loading="loading">
                                <v-icon>save</v-icon>
                                {{ "သိမ်းမည်" }}
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="mt-3">

                            <v-row>

                                <v-col cols="12" align="center">
                                    <v-img width="500" height="316" style="border: 1px solid #ddd" :src="photo">
                                    </v-img>
                                    <p class="dark--gray caption mt-2">
                                        Gift Card Size (500 x 316)px
                                    </p>
                                    <v-btn class="primary my-5" small rounded depressed :loading="isSelecting"
                                        @click="onFileSelect">
                                        <v-icon>cloud_upload</v-icon>
                                        ပုံတင်မည်
                                    </v-btn>
                                    <input ref="uploader" class="d-none" type="file" accept="image/*"
                                        @change="onFileChange" />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "ခေါင်းစဥ်" }} -
                                    </p>
                                    <v-text-field solo background-color="grey lighten-2" flat rounded class="dark--text"
                                        v-model="title" type="text">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "ဖွင့်ထားမည်" }} -
                                    </p>
                                    <v-select solo background-color="grey lighten-2" flat rounded class="dark--text"
                                        :items="activeItems" v-model="active" item-text="text" item-value="value">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "သက်တမ်းကုန်ဆုံးရက်" }} -
                                    </p>
                                    <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field solo background-color="grey lighten-2" flat rounded
                                                class="dark--text" v-model="expireDate" readonly v-bind="attrs"
                                                v-on="on">
                                                <template v-slot:append>
                                                    <v-icon>event</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="expireDate" @input="dateMenu = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "ဖော်ပြချက်" }} -
                                    </p>
                                    <v-textarea solo background-color="grey lighten-2" flat rounded class="dark--text"
                                        v-model="description" type="text">
                                    </v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "SMS စာသား" }} -
                                    </p>
                                    <v-textarea solo background-color="grey lighten-2" flat rounded class="dark--text"
                                        v-model="smsTemplate" type="text"
                                        placeholder="Congratulations ! You got {point} MMK as a gift.">
                                    </v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "Notification စာသား" }} -
                                    </p>
                                    <v-textarea solo background-color="grey lighten-2" flat rounded class="dark--text"
                                        v-model="notificationTemplate" type="text"
                                        placeholder="Congratulations ! You got {point} MMK as a gift.">
                                    </v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="dark--text body-2 font-weight-bold">
                                        {{ "Notification ခေါင်းစဥ်" }} -
                                    </p>
                                    <v-text-field solo background-color="grey lighten-2" flat rounded class="dark--text"
                                        v-model="notificationTitle" type="text">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import File from "../../api/model/File"
import Camping from "../../api/model/Camping";
export default {
    name: "CampingAdd",
    data: function () {
        return {
            campingId: this.$route.params.campingId,
            loading: false,
            isSelecting: false,
            selectedFile: null,
            photo: null,
            title: null,
            description: null,
            active: true,
            expireDate: null,
            dateMenu: false,
            smsTemplate: null,
            notificationTemplate: null,
            notificationTitle: null,
            activeItems: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        };
    },
    methods: {
        getCampingData: async function () {
            try {
                let result = await Camping.getInfo(this.campingId, this.token);

                // Assigning
                this.photo = result.photo;
                this.title = result.title;
                this.description = result.description;
                this.active = result.active
                this.expireDate = new Date(result.expireDate).toISOString().split('T')[0];
                this.smsTemplate = result.smsTemplate;
                this.notificationTemplate = result.notificationTemplate
                this.notificationTitle = result.notificationTitle
            } catch (error) {
                console.log("Error: ", error);
                this.$store.dispatch("MAKE_ERROR", "Cannot get camping data !");
            }
        },
        saveItem: async function () {
            this.loading = true;

            var camping = {
                photo: this.photo,
                title: this.title,
                description: this.description,
                active: this.active,
                expireDate: new Date(this.expireDate),
                smsTemplate: this.smsTemplate,
                notificationTemplate: this.notificationTemplate,
                notificationTitle: this.notificationTitle
            }

            try {
                await Camping.updateInfo(this.campingId, camping, this.token);
                this.$router.push("/campings");
            } catch (err) {
                this.loading = false;
                this.$store.dispatch("MAKE_ERROR", "Cannot Add Camping !");
            }
        },
        onFileSelect: function () {
            this.isSelecting = true;
            window.addEventListener(
                "focus",
                () => {
                    this.isSelecting = false;
                },
                { once: true }
            );
            this.$refs.uploader.click();
        },
        onFileChange: async function (e) {
            // When the upload file is changed
            this.selectedFile = e.target.files[0];
            // Try uploading the photo
            try {
                let result = await File.uploadPhoto(this.selectedFile, "news", this.token);

                console.log("result: ", result);

                this.photo = result.url;
                this.isSelecting = false
            } catch (error) {
                console.log("Error : ", error);
            }
        },

    },
    created: async function () {
        await this.getCampingData();
    },
    computed: {
        token: function () {
            return this.$store.state.user.token
        }
    }
};
</script>